import script from "./TaskNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskNode.vue?vue&type=script&setup=true&lang=js"

import "./TaskNode.vue?vue&type=style&index=0&id=323c6042&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323c6042"]])

export default __exports__